import { useState } from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import SearchIcon from "../../svg/SearchIcon";

type Props = {
  setSearchFilter: Function;
  searchFilter?: string;
  label?: string;
  placeholder?: string;
  customHeight?: string;
  fontSize?: string;
};

const SearchBar = ({
  setSearchFilter,
  searchFilter = "",
  label = "Search",
  placeholder = "Search",
  customHeight = "38px",
  fontSize = "16px",
}: Props) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={styles.container(theme, isFocused, customHeight)}>
      <div style={styles.icon}>
        <SearchIcon
          fill={
            isFocused
              ? theme.colors_ds.PRIMARY_TEXT_MAIN
              : theme.colors_ds.NEUTRAL_ICON_WEAK
          }
        />
      </div>

      {/*{isFocused && <label style={styles.label(theme)}>{label}</label>}*/}
      <input
        type="text"
        style={styles.input(theme, fontSize)}
        value={searchFilter}
        onChange={(e) => setSearchFilter(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchBar;

const styles = {
  container: (theme: Theme, isFocused: boolean, customHeight: string) => ({
    width: "100%",
    height: customHeight,
    position: "relative" as "relative",
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
    display: "flex",
    flexDirection: "row" as "row",
    alignItems: "center",
    border: `1px solid ${
      isFocused
        ? theme.colors_ds.PRIMARY_TEXT_MAIN
        : theme.colors_ds.NEUTRAL_BORDER_DEFAULT
    }`,
    borderRadius: "8px",
    transition: "border-color 0.3s ease",
  }),
  input: (theme: Theme, fontSize: string) => ({
    width: "100%",
    height: "24px",
    padding: "0 16px",
    border: "none",
    outline: "none",
    fontFamily: "var(--font-Medium)",
    fontSize,
    lineHeight: "24px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    caretColor: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    backgroundColor: "transparent",
  }),
  icon: {
    paddingLeft: "16px",
    display: "flex",
    alignItems: "center",
  },
  label: (theme: Theme) => ({
    padding: "4px 16px 0 16px",
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.PRIMARY_TEXT_MAIN,
  }),
};
